<template>
  <div>
    <div class="base-input-text__label">
      {{ label }}
    </div>
    <div
      v-if="!editMode"
      class="base-input-text__input__container"
      :class="{'base-input-text--editable': !readonly}"
      @click="startEditing"
    >
      <template v-if="!innerValue && !readonly">
        <!-- update icon -->
        <base-icon
          icon="icon-plus"
          class="mr-2"
        /> <span class="base-input-text__placeholder base-input-text__value">
          {{ placeholder }}
        </span>
      </template>

      <template v-else>
        <span class="base-input-text__placeholder">
          <slot :value="innerValue">{{ innerValue }}</slot>
        </span>
      </template>
    </div>
    <div v-if="editMode">
      <div class="d-flex">
        <the-mask
          v-if="mask"
          ref="input"
          v-model.trim="innerValue"
          class="base-input-text__input"
          :mask="mask"
          masked
          :type="type"
          :placeholder="placeholder"
          @keypress.enter.native="doBlur"
          @blur.native="stopEditing"
        />
        <input
          v-else
          ref="input"
          v-model.trim="innerValue"
          v-bind="$attrs"
          class="base-input-text__input"
          :type="type"
          :placeholder="placeholder"
          @keypress.enter="doBlur"
          @blur="stopEditing"
        >
        <base-icon
          class="ml-2"
          icon="check-black"
          @click="stopEditing"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
  name: 'BaseInputText',
  components: { TheMask },
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'text',
    },
    mask: {
      type: Array,
      default: null,
    },
    label: {
      type: String,
      default: 'Label',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editMode: false,
      innerValue: '',
    };
  },
  watch: {
    value: {
      handler(val) {
        this.innerValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    doBlur() {
      if (this.mask) {
        this.$refs.input.$el.blur();
      } else {
        this.$refs.input.blur();
      }
    },
    startEditing() {
      if (this.readonly) {
        return;
      }
      this.editMode = true;
      this.$nextTick().then(() => {
        if (this.mask) {
          this.$refs.input.$el.focus();
        } else {
          this.$refs.input.focus();
        }
      });
    },
    stopEditing() {
      this.editMode = false;
      this.$emit('input', this.innerValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-input-text {
    &--editable{
        cursor: pointer;
    }
    &__label {
        font-family: $font-family-sans-serif-light;
        font-style: normal;
        font-weight: normal;
        font-size: 0.75rem;
        line-height: 14px;
        letter-spacing: 0.105px;
        text-transform: uppercase;
        color: #AAAAAA;
        height: 20px;
        display: flex;
        align-items: center;
    }
    &__input__container {
        height: 28px;
        display: flex;
        align-items: center;
    }
    &__input {
        width: 100%;
    }
    &__placeholder{
      font-family: $font-family-sans-serif-regular;
      font-size: 0.875rem;
      line-height: 16px;
    }
}
</style>
